import Component from '@bythepixel/component-loader';
import MicroModal from 'micromodal';
import cookieIsSet from '@Core/utility/cookieIsSet';

export default class ModalPopup extends Component {
  static selector = '[data-comp-modal-popup]';

  constructor(containerEl) {
    super(containerEl);
    this.modal = this.$container.querySelector('[data-comp-modal]');
    this.modalId = this.modal.getAttribute('id');
    this.cookieName = this.modalId.replace('-modal', '');

    // Modal only shows up if cookie is not set
    if (!cookieIsSet(this.cookieName)) {
      this.modalController = MicroModal;

      // Wait for seven seconds, then show the modal on scroll if window.pageYOffset > 500px
      setTimeout(() => {
        const showModal = () => {
          if (window.pageYOffset > 500) {
            this.setCookie();
            this.modalController.show(this.modalId, {
              awaitCloseAnimation: true,
              disableScroll: true,
              openClass: 'modal--open',
            });

            window.removeEventListener('scroll', showModal);
          }
        };

        window.addEventListener('scroll', showModal);
      }, 7000);
    }
  }

  setCookie() {
    const expirationDate = new Date();

    // Cookie is set to expire in 24 hours
    expirationDate.setDate(expirationDate.getDate() + 1);

    document.cookie = `${this.cookieName}=set; expires=${expirationDate}; path=/`;
  }
}
